import React, { memo } from "react"
import { MixtureNode as MixtureNodeType } from "@features/builder/graph/types"
import NodeContainer from "./NodeContainer"

export const MixtureNode = memo((node: MixtureNodeType) => {
  return (
    <NodeContainer node={node}>
      <div className="graph-node-container">
        <div className="graph-node-type graph-node-mixture">{node.type}</div>
        <div className="graph-node-label">{node.data.label}</div>
      </div>
    </NodeContainer>
  )
})

MixtureNode.displayName = "MixtureNode"
